import { Injectable } from '@angular/core';
import { GerinusService } from '../lib/gerinus.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ReturnRequestTypeService extends GerinusService {

  constructor(public http: HttpClient) {
    super(http);
    this.entityName = 'tipo_devolucao_solicitacao';
    this.idField = 'TDS_CodigoTipo'
    this.model = 'DevolucaoSolicitacaoModel'
  }
}
